<template>
  <article class="insight-card">
    <h3 class="insight-card__title">{{ insight.title }}</h3>
    <blockquote class="insight-card__quote font-serif">{{ insight.quote }}</blockquote>
    <span class="insight-card__byline font-mono">
      {{ insight.personaShortId }} · {{ insight.segmentShortId }}
    </span>
  </article>
</template>

<script setup lang="ts">
import type { Insight } from '@/types/verdict';
defineProps<{ insight: Insight }>();
</script>

<style scoped lang="scss">
.insight-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-5);
  background: var(--paper);
  border: var(--border);
  border-radius: var(--r-4);
  box-shadow: var(--shadow-1);

  animation: settle var(--d-slow) var(--ease-settle) both;

  &__title {
    margin: 0;
    font-size: var(--fs-h3);
    color: var(--ink);
  }

  &__quote {
    margin: 0;
    font-size: 20px;
    line-height: 1.32;
  }

  &__byline { color: var(--stone); }
}

@keyframes settle {
  from { transform: translateY(16px); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .insight-card { animation: none; }
}
</style>
